import { Deferred } from '@inertiajs/react'
import { AgentPerformanceTable } from '@/components/analytics/AgentPerformanceTable'
import { PanelSkeleton } from '@/components/analytics/PanelSkeleton'
import { usePanel } from '@/components/analytics/usePanel'
import type { AgentPerformancePanel } from '@/types/analytics'

export function AgentsSection() {
  return (
    <Deferred data="agent_performance" fallback={<PanelSkeleton className="h-64" />}>
      <AgentPerformanceDeferred />
    </Deferred>
  )
}

function AgentPerformanceDeferred() {
  const data = usePanel<AgentPerformancePanel>('agent_performance')
  return data ? <AgentPerformanceTable data={data} /> : null
}
